// in this global variable the json object will be saved
var searchJson = null;

// This function loads the search.json, parses it and saves it in the searchJson variable.
function loadSearchJson() {
    var req = new XMLHttpRequest();
    req.addEventListener('load', function() {
        searchJson = JSON.parse(this.responseText);
        for(var i=0; i < searchJson.length; i++)
            if(searchJson[i].title == "")
                searchJson.splice(i--, 1);
    });
    req.open("GET", baseUrl + "search.json");
    req.send();
}
// It is called immediately
loadSearchJson();

// When the DOM is ready the search input field is prepared.
window.addEventListener('DOMContentLoaded', function() {
    // The text input gets an input handler that calls the search function with the input string
    document.querySelector('.nav-list-search').addEventListener('input', function() {
        search(this.value)        
    });
});